<template>
    <div :class="[{ 'cursor-pointer': permission === true }]"
        class="position-re project__detail-atttachment mobile__bg--withPadding" @dragenter="handleDragOver"
        @mouseleave="showDropZone = false" @dragleave="handleDragLeave" @dragover="handleDragOver">
        <DragAndDropDivCompo v-if="showDropZone && permission" @handleDrop="(e) => handleDrop(e)"
            :extensions="props.extensions" class="position-ab w-100 h-100 drag_drop-compo"
            :class="{ 'z-index-9': showDropZone === true }" @dragLeave="showDropZone = false"
            @drop="showDropZone = false">
        </DragAndDropDivCompo>
        <div v-if="!props.hideHeader" class="d-flex justify-content-between">
            <h4 class="task-details-subtitle m-0"
                :class="{ 'font-size-16 font-weight-600': clientWidth <= 767, 'font-size-14 font-weight-700': clientWidth > 767 }">
                {{ $t('Attachments.attachments') }}({{ attachments.length }})
                <span class="custom-popover position-re pl-5px" v-if="permission === true && clientWidth > 767">
                    <img src="@/assets/images/help_icon.png" alt="">
                    <span class="popover-content">{{ $t('Attachments.drag_file') }}</span>
                </span>
            </h4>
            <div class="d-flex align-items-center">
                <span v-if="visibleAttachments.length > 0"
                    class="d-block text-right p-1 blue text-decoration-underline font-weight-500 font-size-14 cursor-pointer"
                    @click="downloadAllImages()">Download All</span>
                <label for="UploadedFile" v-if="permission === true">
                    <img class="cursor-link cursor-pointer" src="@/assets/images/black_plus.png" />
                </label>
            </div>
        </div>
        <input type="file" id="UploadedFile" hidden multiple ref="attach_files" :accept="extensions"
            @change.prevent.stop="uploadFiles" />
        <div class="drag-and-drop-attchement" v-if="visibleAttachments.length === 0">
            <img :src="draganddropImg" alt="draganddropImg" />{{ $t('Attachments.drop_file') }}
            <span class="text-decoration-underline">{{ $t('Attachments.browse') }}</span>
        </div>
        <div class="slider-main p-0" ref="sliderMain" @click="attchmentDivClick">
            <Attchment v-for="(attachment, index) in visibleAttachments" :key="attachment.id" :data="attachment"
                :isDelete="permission === true" @delete="$emit('update:delete', attachment)" :isSpinner="isSpinner"
                @click="(event) => handleAttachmentClick(event, index)" />

            <SpinnerComp is-spinner="isSpinner" v-if="isSpinner && visibleAttachments.length === 0" />
            <div ref="loadMoreTrigger" class="load-more-trigger"></div>
        </div>
        <div class="d-block text-right p-1 blue text-decoration-underline font-weight-500 font-size-14 see__all"
            @click="$emit('seAll', selectedData.ProjectID ? 'task' : 'project')">{{ $t('Attachments.see_all') }}</div>

        <ImagesPreviewer v-if="transformedAttachments.length" :showPreviewer="showPreviewer"
            :items="transformedAttachments" :activeIndex="activeIndex" @close="closePreviewer"
            @loadMore="loadMoreAttachments" :config="{ handlesTimer: 2000 }" />
    </div>
</template>

<script setup>
/* eslint-disable */
import { defineComponent, ref, inject, watch, onMounted, onUnmounted, nextTick } from "vue";
import Attchment from "@/components/atom/Attachments/AttachmentImage.vue";
import SpinnerComp from "@/components/atom/SpinnerComp/SpinnerComp.vue";
import DragAndDropDivCompo from "@/components/atom/DragAndDropDivCompo/DragAndDropDivCompo.vue";
import { useToast } from "vue-toast-notification";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import JSZip from "jszip";
import ImagesPreviewer from "@/components/organisms/ImagePreviewer/ImagesPreviewer.vue";
import * as env from "@/config/env";
import { storageHelper } from "@/composable/commonFunction";
import { useRouter } from 'vue-router';

const { getStorageImage, getStorageImageServerStorage } = storageHelper();
const { t } = useI18n();
const route = useRoute();
const companyId = inject("$companyId");
watch(route, (newVal) => {
    if (newVal && newVal.hash) {
        document.querySelector(newVal.hash).scrollIntoView();
    }
})
defineComponent({
    name: "AttachmentsComponent"
});
const router = useRouter()
//IMAGES

const draganddropImg = require("@/assets/images/svg/draganddropImg.svg");
const clientWidth = inject("$clientWidth");

const props = defineProps({
    attachments: {
        type: Array,
        default: () => []
    },
    permission: {
        type: Boolean,
        default: false
    },
    extensions: {
        type: Array,
    },
    isSpinner: {
        type: Boolean
    },
    selectedData: {
        type: Object
    },
    hideHeader: {
        type: Boolean,
        default: false
    },
    addTrigger: {
        type: Number,
        default: 0
    }
});
const showDropZone = ref(false);
const emit = defineEmits(["update:add", "update:delete", "seAll"]);
// eslint-disable-next-line
const extensions = ref("");
extensions.value = props.extensions.map(exe => exe.name).join();
const $toast = useToast();
const attach_files = ref(null);
const showPreviewer = ref(false);
const activeIndex = ref(0);
const visibleAttachments = ref([]);
const itemsPerLoad = ref(15);
const isLoading = ref(false);
const transformedAttachments = ref([]);
const sliderMain = ref(null);
const loadMoreTrigger = ref(null);
let observer = null;
const setupIntersectionObserver = () => {
    nextTick(() => {
        const options = {
            root: sliderMain.value,
            rootMargin: "0px",
            threshold: 0.1
        };

        observer = new IntersectionObserver((entries) => {
            if (entries[0]?.isIntersecting && !isLoading.value) {
                const currentLength = visibleAttachments.value.length;
                if (currentLength < props.attachments.length) {
                    loadMoreAttachments();
                }
            }
        }, options);

        if (observer && loadMoreTrigger.value) {
            observer.observe(loadMoreTrigger.value);
        }
    });
};

onMounted(() => {
    setupIntersectionObserver();
});

onUnmounted(() => {
    if (observer) {
        observer.disconnect();
    }
});


const loadMoreAttachments = async () => {
    if (isLoading.value) return;

    const currentLength = visibleAttachments.value.length;
    if (currentLength >= props.attachments.length) return;

    isLoading.value = true;

    try {
        const nextBatch = props.attachments.slice(
            currentLength,
            currentLength + itemsPerLoad.value
        );

        const transformedBatch = await fetchAttachmentUrls(nextBatch);

        visibleAttachments.value = [...visibleAttachments.value, ...nextBatch];
        transformedAttachments.value = [...transformedAttachments.value, ...transformedBatch];
    } catch (error) {
        console.error("Error fetching or transforming attachments:", error);
    } finally {
        isLoading.value = false;
    }
};

const uploadFiles = (event) => {
    const files = Array.from(event.target.files || []);

    let arr = [];
    let isErrorInUpload = false;
    props.extensions.forEach((v) =>
        arr.push(v.name.replaceAll(" ", "_").toLowerCase())
    );

    files.forEach((file) => {
        if (file == null) {
            isErrorInUpload = true;
            $toast.error(t("Toast.Please_select_valid_file"), {
                position: "top-right",
            });
            return;
        }
        let fileName = file.name;
        var ele = fileName.substring(fileName.lastIndexOf(".") + 1);

        const isExists = arr.includes("." + ele.toLowerCase());
        if (!isExists) {
            isErrorInUpload = true;
            if (props.extensions.length > 1) {
                $toast.error(t("Toast.require_image_format_message"), {
                    position: "top-right",
                });
            } else {
                $toast.error(t("Toast.You_have_to_add_extension_in_setting"), {
                    position: "top-right",
                });
            }
            return;
        }
    });

    if (!isErrorInUpload) {
        emit("update:add", files);
    }
    attach_files.value.value = null;
}

const openFilePicker = () => {
    if (props.permission === true) {
        attach_files.value?.click();
    }
}

watch(() => props.addTrigger, (newVal, oldVal) => {
    if (newVal !== oldVal) {
        openFilePicker();
    }
})

const handleDrop = (files) => {
    emit("update:add", files);
}

const attchmentDivClick = (clickEvent) => {
    if (clickEvent.target.nodeName === 'DIV' && props.permission === true) {
        openFilePicker();
    }
}
const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const rect = event.target.getBoundingClientRect();
    const isLeavingContainer = (
        event.clientX < rect.left ||
        event.clientX >= rect.right ||
        event.clientY < rect.top ||
        event.clientY >= rect.bottom
    );
    if (isLeavingContainer) {
        showDropZone.value = false;
    }
}
const handleDragOver = (event) => {
    showDropZone.value = true;
    event.preventDefault();
    event.stopPropagation();
};

const handleAttachmentClick = (event, index) => {
    sessionStorage.setItem(
        "preview_attachments",
        JSON.stringify(transformedAttachments.value)
    );

    const routeData = router.resolve({
        name: "PreviewAttachments",
        params: {
            cid: companyId.value
        },
        query: {
            index
        }
    });

    window.open(routeData.href, "_blank");
};

const openPreviewer = (index) => {
    activeIndex.value = index;
    showPreviewer.value = true;
};

const closePreviewer = () => {
    showPreviewer.value = false;
};

async function downloadAllImages() {
    if (!env?.STORAGE_TYPE || env.STORAGE_TYPE !== 'server') {
        const attachments = props.selectedData?.attachments ?? [];
        const zip = new JSZip();

        const filenameMap = new Map();
        const imagePromises = attachments.map(async (attachment) => {
            try {
                const res = await getStorageImage({
                    companyId: companyId.value,
                    data: {
                        url: attachment.url,
                    },
                });

                if (res) {
                    const blob = await fetchImageAsBlob(res);
                    if (blob) {
                        let originalName = attachment.filename;
                        let name = originalName;
                        let count = filenameMap.get(originalName) || 0;

                        if (count > 0) {
                            const extIndex = originalName.lastIndexOf('.');
                            if (extIndex !== -1) {
                                name = `${originalName.slice(0, extIndex)} (${count})${originalName.slice(extIndex)}`;
                            } else {
                                name = `${originalName} (${count})`;
                            }
                        }

                        filenameMap.set(originalName, count + 1);
                        zip.file(name, blob);
                    }
                }
            } catch (error) {
                console.error('Error fetching or updating the file URL:', error);
            }
        });

        await Promise.allSettled(imagePromises);

        zip.generateAsync({ type: "blob" }).then((zipBlob) => {
            const zipName = props.selectedData.ProjectID
                ? props.selectedData.TaskName
                : props.selectedData.ProjectName;

            saveAs(zipBlob, `${zipName}_attachments.zip`);
        });
    } else {
        const attachments = props.selectedData?.attachments ?? [];
        const zip = new JSZip();

        const filenameMap = new Map();

        const imagePromises = attachments.map(async (attachment) => {
            try {
                const res = await getStorageImageServerStorage({
                    filePath: attachment.url,
                    companyId: companyId.value,
                    tuhumbnailSize: null
                });

                if (res?.downloadUrl) {
                    const blob = await fetchImageAsBlob(res.downloadUrl);
                    if (blob) {
                        let originalName = attachment.filename;
                        let name = originalName;
                        let count = filenameMap.get(originalName) || 0;

                        if (count > 0) {
                            const extIndex = originalName.lastIndexOf('.');
                            if (extIndex !== -1) {
                                name = `${originalName.slice(0, extIndex)} (${count})${originalName.slice(extIndex)}`;
                            } else {
                                name = `${originalName} (${count})`;
                            }
                        }
                        filenameMap.set(originalName, count + 1);
                        zip.file(name, blob);
                    }
                }
            } catch (error) {
                console.error('Error handling server-stored attachment:', error);
            }
        });

        await Promise.allSettled(imagePromises);

        zip.generateAsync({ type: "blob" }).then((zipBlob) => {
            const zipName = props.selectedData.ProjectID
                ? props.selectedData.TaskName
                : props.selectedData.ProjectName;
            saveAs(zipBlob, `${zipName}_attachments.zip`);
        });
    }
}

async function fetchImageAsBlob(url) {
    try {
        const response = await fetch(url);
        return await response.blob();
    } catch (error) {
        console.error(`Failed to fetch image: ${url}`, error);
        return null;
    }
}
function saveAs(blob, filename) {
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
}

async function fetchAttachmentUrls(attachments) {
    return await Promise.all(
        attachments.map(async (attachment) => {
            const filename = attachment.filename || attachment.name || 'attachment';
            const baseName = filename.replace(/\.[^/.]+$/, "");
            const storagePath = attachment.url || attachment.path || attachment.objectKey || attachment.object_key || '';
            let properUrl = storagePath;

            try {
                if (storagePath && (!env?.STORAGE_TYPE || env.STORAGE_TYPE !== 'server')) {
                    const newUrl = await getStorageImage({
                        companyId: companyId.value,
                        data: { url: storagePath },
                        isCache: true,
                    });

                    if (newUrl) properUrl = newUrl;
                } else if (storagePath) {
                    const res = await getStorageImageServerStorage({
                        filePath: storagePath,
                        companyId: companyId.value,
                        tuhumbnailSize: null
                    });
                    if (res?.downloadUrl || res?.url) {
                        properUrl = res.downloadUrl || res.url;
                    }
                }
            } catch (err) {
                console.error(`Error fetching URL for ${filename}:`, err);
            }

            return {
                id: attachment.id,
                title: baseName,
                name: filename,
                alt: `${baseName} file`,
                type: attachment.type,
                ext: attachment.extension,
                url: properUrl,
                path: storagePath,
                size: attachment.size ?? attachment.fileSize ?? attachment.filesize ?? attachment.file_size ?? attachment.mediaSize,
            };
        })
    );
}

const initAttachments = async (attachments) => {
    visibleAttachments.value = [];
    transformedAttachments.value = [];

    const list = attachments || [];
    if (!list.length) return;

    const alreadyLoaded = visibleAttachments.value.length || itemsPerLoad.value;
    const take = Math.min(alreadyLoaded, list.length);

    const initialBatch = list.slice(0, take);

    visibleAttachments.value = initialBatch;
    const fetchedAttachments = await fetchAttachmentUrls(initialBatch);
    transformedAttachments.value = fetchedAttachments;
};

watch(
    () => props.selectedData?.ProjectID,
    async () => {
        await initAttachments(props.attachments);
    },
    { immediate: true }
);

watch(
    () => props.attachments,
    async (newVal, oldVal) => {
        if (newVal === oldVal) return;

        await initAttachments(newVal);
    },
    { deep: true }
);

</script>
<style scoped src="./style.css"></style>
<style>
.slider-main {
    display: flex;
    flex-wrap: nowrap;
    position: relative;
    width: 100%;
    z-index: 5;
    height: 60px;
    margin-top: 20px;
    gap: 10px;
    overflow-x: auto;
    overflow-y: hidden;
}

.slider-main > * {
    flex: 0 0 auto;
}

.slider-main::-webkit-scrollbar {
    height: 6px;
}

.slider-main::-webkit-scrollbar-thumb {
    border-radius: 999px;
}

.slider-main {
    scrollbar-width: thin;
}

.drag_drop-compo {
    top: 33px;
}

.custom-popover {
    top: 2px;
}

@media(max-width: 767px) {
    .slider-main {
        height: 70px;
        overflow-y: hidden;
    }

    .see__all {
        padding-right: 0 !important;
    }
}

.load-more-trigger {
    width: 1px;
    height: 1px;
    visibility: hidden;
    position: relative;
    margin-left: 10px;
}
</style>
